let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("feg87"), load("hOsjc")]).then(() => parcelRequire('92Mdh'));